import type { TimeSeriesChartContent } from '@/features/time-series-chart/types/TimeSeriesChartModel.types';
import type { TimeSeries, TimeSeriesChartHighlight } from '@/shared/charts';

export function getChartHighlight(
  { series, rangeTrack }: TimeSeriesChartContent,
  highlightedSeriesIds: string[]
): TimeSeriesChartHighlight {
  const highlightedIds = new Set(highlightedSeriesIds);
  const lineSeriesIds = series.map(({ id }) => id);
  const laneIds = rangeTrack?.lanes.map((lane) => lane.id) ?? [];

  return {
    seriesIds: lineSeriesIds.filter((seriesId) => highlightedIds.has(seriesId)),
    laneIds: laneIds.filter((laneId) => highlightedIds.has(laneId)),
  };
}

export function getPreviewSeriesId(
  series: TimeSeries[],
  highlightedSeriesIds: string[],
  selectedSeriesIds: string[]
): string | undefined {
  const lineSeriesIds = new Set(series.map(({ id }) => id));
  const findLastLineSeriesId = (seriesIds: string[]) =>
    [...seriesIds].reverse().find((seriesId) => lineSeriesIds.has(seriesId));

  return findLastLineSeriesId(highlightedSeriesIds) ?? findLastLineSeriesId(selectedSeriesIds);
}
